<template>
  <v-data-table
    :headers="prop_headers"
    :items="prop_items"
    class="elevation-1"
    :loading="propLoading"
    loading-text="Загружаю данные"
    item-key="PROP_ID"
    :search="propSearch"
    show-select
    single-select
    locale="ru-RU"
    dense
    :value="value"
    @input="setValue"
  >
    <template v-slot:top>
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Свойства</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="propSearch"
          append-icon="mdi-magnify"
          label="Искать"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
  </v-data-table>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'refPropertiesTable',
  props: ['value'],
  data () {
    return {
      prop_headers: [
        {
          text: 'Наименование',
          value: 'PROP_NAME'
        },
        {
          text: 'Код',
          value: 'PROP_CODE'
        }
      ],
      propLoading: false,
      propSearch: '',
      prop_items: []
    }
  },

  computed: {},
  watch: {
    value (val) {
      if (!val || !val.length || !val[0].PROP_ID) return
      const curr = this.prop_items.findIndex(itm => itm.PROP_ID === val[0].PROP_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.prop_items.splice(curr, 1)
          this.setValue([])
          return
        }
        this.prop_items.splice(curr, 1, val[0])
      } else {
        this.prop_items.push(val[0])
      }
    }
  },
  mounted: function () {
    if (this.prop_items.length === 0) {
      this.getPropList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getPropList () {
      const self = this
      this.propLoading = true
      axios({
        url: '/api/org/references/getPropertiesList.php',
        method: 'POST'
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.prop_items.splice(0, self.prop_items.length, ...resp.data.data)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${err}` })
        })
        .finally(
          this.propLoading = false
        )
    }
  }
}

</script>
